/**
 * Created by Administrator on 2017/11/1.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
import { Location } from "@angular/common";
import { StroageService } from "../service/stroage";
import { FormBuilder } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
declare var alertify: any;
@Component({
  templateUrl: "./editAboutUs.html",
})
export class EditAboutUs implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpService,
    private fileUpload: FileUpload,
    private stroage: StroageService,
    private formBuilder: FormBuilder,
    private location: Location,
    private domSanitizer: DomSanitizer
  ) {}

  private data: any = {
    id: "",
    categoryId: "",
    iconEn: "",
    iconTc: "",
    mediaEn1: "",
    mediaTc1: "",
    mediaEn2: "",
    mediaTc2: "",
    mediaType1: "",
    mediaType2: "",
    contentEn: "",
    contentTc: "",
    subTitleEn: "",
    subTitleTc: "",
    titleEn: "",
    titleTc: "",
    specialShopType: "1",
  };

  private categoryData: any = [];
  private customerTypeData: any = [];
  private isProgress = true;

  private language = "en";

  private id: number = 0;

  private imagePath: string = "";

  private isCreate: boolean = false;

  private mediaType1: string = "0";

  private mediaType2: string = "0";

  private contentEn: string = "<p></p>";

  private contentTc: string = "<p></p>";
  public type: string = "";

  private onReady(str: string): void {
    if (str == "en") {
      this.contentEn = this.data.contentEn;
    } else if (str == "tc") {
      this.contentTc = this.data.contentTc;
    }
  }

  private submit(): void {
    this.http
      .postData(API.aboutUs, {
        id: this.id,
        titleEn: this.data.titleEn,
        titleTc: this.data.titleTc,
        categoryId: this.data.categoryId,
        iconEn: this.data.iconEn,
        iconTc: this.data.iconTc,
        mediaEn1: this.data.mediaEn1,
        mediaTc1: this.data.mediaTc1,
        mediaEn2: this.data.mediaEn2,
        mediaTc2: this.data.mediaTc2,
        mediaType1: this.mediaType1,
        mediaType2: this.mediaType2,
        contentEn: this.data.contentEn,
        contentTc: this.data.contentTc,
        contentType: this.data.contentType,
        subTitleEn: this.data.subTitleEn,
        subTitleTc: this.data.subTitleTc,
        imageEn: this.data.imageEn,
        imageTc: this.data.imageTc,
        messageEn: this.data.messageEn,
        messageTc: this.data.messageTc,
        urlEn: this.data.urlEn,
        urlTc: this.data.urlTc,
        specialShopType: this.data.specialShopType,
      })
      .then((res) => {
        let data = res;
        if (data.status.code == 0 || data.status.code == "0") {
          this.location.back();
          alertify.success(data.status.message);
        } else {
          alertify.error(data.status.message);
        }
      });
  }

  private onChange(str: string): void {
    if (str == "en") {
      this.data.contentEn = this.contentEn;
    } else if (str == "tc") {
      this.data.contentTc = this.contentTc;
    }
  }

  private videoUrl: any;
  private videoUrl2: any;
  private videoUrl3: any;
  private videoUrl4: any;
  private isLocalhost: any = {
    mediaEn1: false,
    mediaEn2: false,
    mediaTc1: false,
    mediaTc2: false,
  };
  private mediaTemp: any = {
    mediaEn1: "",
    mediaEn2: "",
    mediaTc1: "",
    mediaTc2: "",
  };

  private getVideoUrl(mediaUrl, type): any {
    this.isLocalhost[type] = false;
    if (
      mediaUrl.indexOf("www.youtube.com/embed") == -1 &&
      mediaUrl.indexOf("youtu") != -1
    ) {
      let url;
      if (mediaUrl.indexOf("www.youtube.com/watch") != -1) {
        url = mediaUrl.replace("watch?v=", "embed/");
        if (mediaUrl.indexOf("&") != -1) {
          url = url.substring(0, mediaUrl.indexOf("&") - 2);
        }
      } else if (mediaUrl.indexOf("youtu.be") != -1) {
        url = mediaUrl.replace("youtu.be", "www.youtube.com/embed");
      }
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    } else if (
      mediaUrl.indexOf(location.hostname) != -1 ||
      mediaUrl.indexOf("localhost") != -1 ||
      mediaUrl.indexOf("api.naturally-plus.com.tw") != -1 ||
      mediaUrl.indexOf("s3-ap-northeast-1.amazonaws.com") != -1
    ) {
      this.isLocalhost[type] = true;
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    } else if (mediaUrl.indexOf("www.youtube.com/embed") != -1) {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    } else {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(mediaUrl);
    }
  }

  private getData(): void {
    this.http.getData(API.aboutUs + "/" + this.id).then((res) => {
      this.data = res.data;
      this.mediaType1 = this.data.mediaType1.toString();
      this.mediaType2 = this.data.mediaType2.toString();
      this.contentEn = this.data.contentEn;
      this.contentTc = this.data.contentTc;
      this.videoUrl = this.getVideoUrl(this.data.mediaEn1, "mediaEn1");
      this.videoUrl2 = this.getVideoUrl(this.data.mediaEn2, "mediaEn2");
      this.videoUrl3 = this.getVideoUrl(this.data.mediaTc1, "mediaTc1");
      this.videoUrl4 = this.getVideoUrl(this.data.mediaTc2, "mediaTc2");

      this.mediaTemp.mediaEn1 = this.data.mediaEn1;
      this.mediaTemp.mediaEn2 = this.data.mediaEn2;
      this.mediaTemp.mediaTc1 = this.data.mediaTc1;
      this.mediaTemp.mediaTc2 = this.data.mediaTc2;
      this.isProgress = false;
    });
  }

  private getCategoryData(): void {
    this.http.getData(API.activeAboutUsCategory).then((res) => {
      this.categoryData = res.data;
    });
  }

  //內容類別

  private getCustomerType(): void {
    this.http.getData(API.customerType).then((res) => {
      this.customerTypeData = res.data;
    });
  }

  //存储错误信息
  /*formErrors = {
    'contentEnGroup.contentEn':'',
    'contentTcGroup.contentTc':'',
  };*/

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      console.log(this.imagePath);
    });
  }

  private showByLanguage(type: string) {
    this.language = type;
  }

  /*  private changeMediaType1(type:string):void{
    this.mediaType1 = type;
    if(this.language == 'en'){
      this.data.mediaEn1 = '';
    }else {
      this.data.mediaTc1 = '';
    }

  }

  private changeMediaType2(type:string):void{
    this.mediaType2 = type;
    if(this.language == 'en'){
      this.data.mediaEn2 = '';
    }else {
      this.data.mediaTc2 = '';
    }
  }*/

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.type = params["type"];
    });
    this.getCategoryData();
    this.getCustomerType();
    if (this.id != 0) {
      this.getPath();
      this.getData();
    } else {
      this.isCreate = true;
      this.isProgress = false;
    }
  }

  private showIconEn: boolean = false;
  private showIconTc: boolean = false;
  private showMediaEn1: boolean = false;
  private showMediaTc1: boolean = false;
  private showMediaEn2: boolean = false;
  private showMediaTc2: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileUpload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "iconEn":
            self.showIconEn = true;
            break;
          case "iconTc":
            self.showIconTc = true;
            break;
          case "mediaEn1":
            self.showMediaEn1 = true;
            break;
          case "mediaTc1":
            self.showMediaTc1 = true;
            break;
          case "mediaEn2":
            self.showMediaEn2 = true;
            break;
          case "mediaTc2":
            self.showMediaTc2 = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      } else {
        alert(temRes.status.message);
      }
    });
  }

  ngDoCheck() {
    if (this.mediaTemp.mediaEn1 != this.data.mediaEn1) {
      this.mediaTemp.mediaEn1 = this.data.mediaEn1;
      this.videoUrl = this.getVideoUrl(this.data.mediaEn1, "mediaEn1");
    }
    if (this.mediaTemp.mediaEn2 != this.data.mediaEn2) {
      this.mediaTemp.mediaEn2 = this.data.mediaEn2;
      this.videoUrl2 = this.getVideoUrl(this.data.mediaEn2, "mediaEn2");
    }
    if (this.mediaTemp.mediaTc1 != this.data.mediaTc1) {
      this.mediaTemp.mediaTc1 = this.data.mediaTc1;
      this.videoUrl3 = this.getVideoUrl(this.data.mediaTc1, "mediaTc1");
    }
    if (this.mediaTemp.mediaTc2 != this.data.mediaTc2) {
      this.mediaTemp.mediaTc2 = this.data.mediaTc2;
      this.videoUrl4 = this.getVideoUrl(this.data.mediaTc2, "mediaTc2");
    }
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/aboutUs/EditAboutUs.componment.ts